import React, { Component, useEffect } from "react";
import { connect } from "react-redux";

import Projects from "../../pages/Projects";
import SignInContainer from "../SignInContainer";

const ProjectsContainer = (props) => {
  if (props.user) {
    return <Projects user={props.user} taxes={props.taxes} />;
  } else {
    return <SignInContainer />;
  }
};

const mapStateToProps = (state) => ({
  user: state.user,
  taxes: state.taxes,
});

export default connect(mapStateToProps)(ProjectsContainer);
